<div class="container mt-4">
    <div class="row mb-3">
        <div class="col-md-4 d-flex align-items-center">
            <h4 class="font-weight-bold later-color title">
                {{ 'productoConsulta.tituloProducto' | translate }}
            </h4>
            <button
                class="btn btn-success ml-2 rounded-circle p-1 information-message"
                (click)="mostrarTexto()">
                <i class="fas fa-question"></i>
            </button>
        </div>
        <div class="col-md-11 text-end">
            <a
                class="btn btn-success text-white productquery_colorbtn me-2"
                [routerLink]="['/carga-masiva-productos']"
                style="border-radius: 20px">
                <i class="fas"></i>
                Carga masiva de productos
            </a>
            <a
                class="btn btn-success text-white productquery_colorbtn ms-2"
                (click)="addProduct()"
                style="border-radius: 20px">
                <i class="fas"></i>
                Agregar producto
            </a>
        </div>
    </div>

    <div class="float-start mb-3 ml-3">
        <input
            type="text"
            class="form-control"
            id="busqueda"
            placeholder="Buscar"
            [(ngModel)]="busqueda" />
        <span class="bi bi-search text-muted"></span>
    </div>

    <table class="table">
        <thead>
            <tr>
                <th>Tipo producto</th>
                <th>Registro ICA</th>
                <th>Nombre comercial</th>
                <th>Estado</th>
                <th>Presentaciones</th>
                <th>Edición</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let producto of products | filter: busqueda">
                <tr>
                    <td>{{ producto.tipoProducto.nombre }}</td>
                    <td>{{ producto.numeroRegistroIca }}</td>
                    <td>{{ producto.nombreComercial }}</td>
                    <td>
                        <div class="d-flex align-items-center">
                            <p
                                class="mb-0 me-1"
                                [ngClass]="
                                    producto.estado
                                        ? 'productquery_active'
                                        : 'productquery_inactive'
                                ">
                                {{ producto.estado ? 'Activo' : 'Inactivo' }}
                            </p>
                            <button
                                class="btn btn-sm text-white px-2"
                                [ngClass]="{
                                    'btn-success': !producto.estado,
                                    'btn-warning': producto.estado,
                                }"
                                (click)="activarInactivar(producto)">
                                {{ producto.estado ? 'Inactivar' : 'Activar' }}
                            </button>
                        </div>
                    </td>

                    <td>
                        <div class="d-flex align-items-center">
                            <button
                                class="btn btn-outline-info btn-sm me-1"
                                (click)="togglePresentaciones(producto)">
                                {{
                                    producto.showPresentaciones
                                        ? 'Ocultar'
                                        : 'Mostrar'
                                }}
                            </button>
                            <button
                                class="btn btn-sm btn-success"
                                (click)="verPresentaciones(producto)">
                                Administrar
                            </button>
                        </div>
                    </td>

                    <td>
                        <button
                            class="btn btn-primary btn-sm productquery_color"
                            (click)="editarProducto(producto)">
                            Editar
                        </button>
                    </td>
                </tr>

                <tr *ngIf="producto.showPresentaciones">
                    <td colspan="5">
                        <div class="card p-3">
                            <h6>
                                <strong>
                                    Casa productora / Planta productora:
                                </strong>
                                {{ producto.casaProductora }}
                            </h6>
                            <strong>Presentaciones:</strong>
                            <ul>
                                <li
                                    *ngFor="
                                        let presentacion of producto.presentaciones
                                    ">
                                    <strong></strong>
                                    {{
                                        presentacion.empaqueUnidadMedida.empaque
                                            .nombre
                                    }}
                                    de {{ presentacion.cantidad }}
                                    {{
                                        formatUnidadMedida(
                                            presentacion.cantidad,
                                            presentacion.empaqueUnidadMedida
                                                .unidadMedida.nombre
                                        )
                                    }}
                                </li>
                            </ul>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>
